import type { CompanyOption } from '@/hooks/useAvailableCompanies'

interface CompanySelectProps {
  id: string
  options: CompanyOption[]
  value: number | null
  onChange: (companyId: number | null) => void
  className: string
  /** Rótulo da opção "nenhuma em particular" (valor `null`). Sem ele, a
   * empresa é obrigatória. */
  allLabel?: string
  /** Id do texto de ajuda/aviso ligado ao select (`aria-describedby`). */
  describedBy?: string
}

/** Select de empresa dos formulários de criação (Atendimento HUB e "Nova
 * ocorrência"). */
export function CompanySelect({
  id,
  options,
  value,
  onChange,
  className,
  allLabel,
  describedBy,
}: CompanySelectProps) {
  return (
    <select
      id={id}
      aria-describedby={describedBy}
      value={value ?? ''}
      onChange={(e) =>
        onChange(e.target.value === '' ? null : Number(e.target.value))
      }
      className={className}
    >
      {allLabel && <option value="">{allLabel}</option>}
      {options.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </select>
  )
}
